import { db } from '@/main';

export const namespaced = true

export const state = {
         businesses: [],
         customer: {
           id: "",
           name: "",
         },
         business: {
           id: null,
           active: true,
           address: "",
           customer_id: "",
           customer_name: "",
           facebook: "",
           instagram: "",
           name: "",
           phone: "",
           photo_name: "",
           photo_url: "",
					 twitter: "",
					 created_at: null,
					 expiration: null
         },
         dialog: false,
				 editMode: false,
				 
         showComponent: false,
       };

export const mutations = {
	SET_SHOW_COMPONENT(state, data) {
		state.showComponent = data;
	},
	SET_DIALOG(state, data) {
		state.dialog = data
	},
	SET_BUSINESS(state, data) {
		state.business = data
	},
	SET_CUSTOMER(state, data) {
		state.customer = data
	},
	SET_BUSINESSES(state, data) {
		state.businesses = data
	},
	SET_BUSINESS_DIALOG: (state, data) => {
		state.dialog = !state.dialog;
		state.editMode = data.editMode;
		state.business = data.business;
	},
}

export const actions = {
	getbusinesses({ commit, dispatch }) {
		dispatch('setLoaded', true, { root: true })
		return new Promise(resolve => {
			db.collection('bussiness').onSnapshot(function (querySnapshot) {
				let businesses = [];
				querySnapshot.forEach((doc) => businesses.push(doc.data()))
				commit('SET_BUSINESSES', businesses);
				resolve();
			})
			
			//dispatch('setLoaded', true, { root: true })
		});
	},
	toggleBusinessDialog({ commit }, data) {
		commit('SET_BUSINESS_DIALOG', data);
		commit('SET_CUSTOMER', { id: data.business.customer_id, name: data.business.customer_name });
	},
	setBusiness({ commit }, data) {
		commit('SET_BUSINESS', data)
	}
}

export const getters = {
	businessesDialog: (state) => {
		return state.dialog;
	},
	businessForEdit: (state) => {
		return state.business;
	},
	businessDialogEditMode: (state) => {
		return state.editMode;
	},
	customerForEdit: (state) => {
		return state.customer
	},
	currentBusiness: state => {
		return state.business
	}
}